<template>
  <path
    d="M5 19.0002H9V12.0002H3V17.0002C3 18.1002 3.9 19.0002 5 19.0002ZM10 19.0002H20C21.1 19.0002 22 18.1002 22 17.0002V12.0002H10V19.0002ZM3 7.00024V11.0002H22V7.00024C22 5.90024 21.1 5.00024 20 5.00024H5C3.9 5.00024 3 5.90024 3 7.00024Z"
  />
</template>
